import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-address-ind',
  templateUrl: './ui-address-ind.component.html',
  styleUrls: ['./ui-address-ind.component.scss']
})
export class UiAddressIndComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  savedAdd:boolean = true;
  list:any = [
    1,2,3
  ]
}
